import { useRouter } from 'next/router';

import { PHYSICIANS_URL } from '@/lib/constants';
import { useOasApp } from '@/providers';
import { DotCMSInitializationParams } from '@/types/DotCMS';

type WithBasePath = (urlToHandle: string) => string;

export const useBasePath = (): {
  withBasePath: WithBasePath;
} => {
  const { isLocation, scSiteCookie, dotcms } = useOasApp();
  const router = useRouter();
  const currentPath = router.asPath;

  const withBasePath: WithBasePath = (urlToHandle: string) => {
    // Note: For dotcms we only need to remove the initialization params from the url
    if (scSiteCookie?.toLowerCase() === 'dotcms' || dotcms?.dotCmsHostId) {
      let urlStrippedFromConfigurationParams = urlToHandle;
      Object.values(DotCMSInitializationParams).forEach((param) => {
        const regex = new RegExp(`[?&]${param}=[^&]*`, 'i');
        urlStrippedFromConfigurationParams = urlStrippedFromConfigurationParams
          .toString()
          .replace(regex, '');
      });

      return urlStrippedFromConfigurationParams;
    }

    // Todo: revise this when we get to multiple /physicians in the url
    const urlParts = currentPath.split(PHYSICIANS_URL);

    if (isLocation && !dotcms?.dotCmsHostId) {
      return `${urlParts[0]}${PHYSICIANS_URL}${urlToHandle}`;
    }

    return urlParts.length > 1 ? `${urlParts[0]}${urlToHandle}` : urlToHandle;
  };

  return {
    withBasePath,
  };
};
